<div class="title-head" fxLayout="column">
  <div class="mdTitle-f title-wrapper">
    @if (confirmChanges) {
      {{ "carVariant.changesReceived" | translate }}
    } @else {
      @if (!isMotorcycle) {
        {{ "carVariant.carModelConfirmation" | translate }}
      }
      @if (isMotorcycle) {
        {{ "carVariant.motorcycleModelConfirmation" | translate }}
      }
    }

    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="content-wrapper">
  @if (confirmChanges) {
    <div>
      <div class="content-block">
        <div>
          <mat-icon class="icon-tick">check_circle_outline</mat-icon>
        </div>
        <div>
          {{ "carVariant.revisedQuoteWillBeSent" | translate }}
        </div>
      </div>
      <div class="model-block">
        {{ "carVariant.selectedCarModel" | translate }}
        <br />
        <b>{{ selectedCar.vehicle }}</b>
      </div>
      <div class="close-button-wrapper">
        <button
          mat-flat-button
          mat-dialog-close
          color="primary"
          class="full-width"
          >
          Close
        </button>
      </div>
    </div>
  } @else {
    <div>
      @if (!isMotorcycle) {
        <div class="label-desc">
          {{ "carVariant.pleaseConfirmCarModelVariant" | translate }}
        </div>
      }
      @if (isMotorcycle) {
        <div class="label-desc">
          {{ "carVariant.pleaseConfirmMotorcycleModelVariant" | translate }}
        </div>
      }
      @if (!isMotorcycle) {
        <div class="label-desc model-text-wrapper">
          {{ "carVariant.currentCarModel" | translate }}
        </div>
      }
      @if (isMotorcycle) {
        <div class="label-desc model-text-wrapper">
          {{ "carVariant.currentMotorcycleModel" | translate }}
        </div>
      }
      <div class="label-value">
        {{ carData.vehicle }}
      </div>
      @if (selectedCar) {
        <div class="label-desc block2">
          @if (!isMotorcycle) {
            <div>{{ "carVariant.selectedCarModel" | translate }}</div>
          }
          @if (isMotorcycle) {
            <div>{{ "carVariant.selectedMotorcycleModel" | translate }}</div>
          }
          <b>{{ selectedCar.vehicle }}</b>
        </div>
      }
      @if (carVars) {
        <div>
          <div class="dropdown-wrapper">
            <mat-form-field  class="full-width drop-form">
              <mat-label>{{ "carVariant.selectCarModel" | translate }}</mat-label>
              <mat-select
                #carSelect
                (selectionChange)="onCarSelectChange($event)"
                >
                @for (carVar of carVars; track carVar) {
                  <mat-option [value]="carVar">
                    {{ carVar.vehicle }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (selectedCar) {
              <div class="confirm-button-wrapper">
                <button
                  mat-flat-button
                  color="primary"
                  class="full-width"
                  (click)="saveChanges(selectedCar)"
                  >
                  {{ "carVariant.confirmChange" | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="group-button-wrapper">
          @if (!isMotorcycle) {
            <button
              mat-stroked-button
              color="secondary"
              class="full-width edit-button-wrapper"
              (click)="editCarVariant()"
              [disabled]="!editCarModel"
              >
              {{ "carVariant.editCarModel" | translate }}
            </button>
          }
          @if (isMotorcycle) {
            <button
              mat-stroked-button
              color="secondary"
              class="full-width edit-button-wrapper"
              (click)="editCarVariant()"
              [disabled]="!editCarModel"
              >
              {{ "carVariant.editMotorcycleModel" | translate }}
            </button>
          }
          <button
            mat-flat-button
            mat-dialog-close
            color="primary"
            class="full-width confirm-button-wrapper"
            (click)="proceedQuotation()"
            >
            {{ "carVariant.correct&proceed" | translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
